import isMobile from 'ismobilejs'


const styles = (theme) => ({
    modal: {
        "& .MuiPaper-root" :{
          maxHeight:'90%',
          width:'90%'
        }
      },
    paper: {
        marginTop: theme.spacing(9),
        marginBottom: theme.spacing(4),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        marginTop:'25px'
    },
    submit2: {
        marginTop:'20px'
    },
    designerIcon:{
        marginBottom:'25px'
    },
    aaLoader: {
        height: '100vh',
        display: 'grid',
        justifyContent: 'center',
        alignContent: 'center'
    },
    aaLoaderModal: {
        height: isMobile.any ? '100vh' : '70vh' ,
        width: isMobile.any ? '100%' : '350px',
        display: 'grid',
        justifyContent: 'center',
        alignContent: 'center'
    },
});

export default styles